import React, { useState, useEffect } from 'react';
import { IoLogoGooglePlaystore } from 'react-icons/io5';
import { Link, useNavigate } from 'react-router-dom';

export default function Services() {
  const navigate = useNavigate();
  const [visibleSections, setVisibleSections] = useState(new Set());

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('[data-section]');
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.75 && rect.bottom > 0;
        
        if (isVisible) {
          setVisibleSections(prev => new Set([...prev, section.getAttribute('data-section')]));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    {
      title: 'Download Media Promosi',
      icon: '/images/panduan/download.jpg',
      desc: 'Download Banner Usaha Konter dihalaman ini.',
      gradient: 'from-blue-600 to-cyan-600',
      link: '/media-promosi',
      features: ['Banner Daftar Harga', 'Banner Melayani Transaksi', 'Kartu Nama Agen', 'Tutorial Penggunaan Aplikasi']
    },
    {
      title: 'Panduan Aplikasi',
      icon: '/images/panduan/phone.jpg',
      desc: 'Klik disini agar Kamu tahu cara menggunakan Aplikasi Kenzie Komunika APK',
      gradient: 'from-red-600 to-pink-600',
      link: '/panduan-aplikasi',
      features: ['Panduan Cara Daftar', 'Panduan Cara Login', 'Cara Transaksi', 'Cara Bayar Tagihan', 'Cara Aktivasi Voucher', 'Cara Memasukkan Kode Referal', 'Cara Daftarkan Downline', 'Cara Binding Dompet Digital']
    },
    {
      title: 'Panduan Daftar QRISku',
      icon: '/images/panduan/qr.jpg',
      desc: 'Daftarkan outlet / toko kamu dengan pembayaran via QRIS di Kenzie Komunika APK',
      gradient: 'from-purple-600 to-blue-600',
      link: '/panduan-daftar-qrisku',
      features: ['Cara Daftar', 'Persyaratan', 'Proses Pendaftaran', 'FAQ']
    }
  ];

  const [sectionHero, setSectionHero] = useState({
      title: "",
      page: "",
      description: "",
      image: "", 
    });
  
    const fetchSectionHero = async () => {
        
      try {
          const res = await fetch(
              `${process.env.REACT_APP_BASE_URL}api/sectionhero/panduan`
          );
  
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
  
          const json = await res.json();
          setSectionHero(json.data[0] || []);
  
      } catch (err) {
          console.error("Fetch Pc error:", err);
      }
    };
    
    useEffect(() => {
      fetchSectionHero();
    }, []);  

  return (
    <div className="min-h-screen bg-slate-400/95  text-slate-700 pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="relative
          h-[32vh] md:h-[40vh] lg:h-[45vh]
          overflow-hidden
          flex items-center justify-center
          bg-white"
      >
        <div className="absolute inset-0">
          <img
            src={`${process.env.REACT_APP_BASE_URL}uploads/images/${sectionHero.image}`}
            alt="background"
            className="w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-slate-950/60"></div>

          {/* Gradient Glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-white"></div>

          {/* Optional Glow Accent */}
          <div className="absolute top-1/4 left-1/3 w-72 h-72 bg-blue-500/20 blur-[120px] rounded-full"></div>
          <div className="absolute bottom-1/4 right-1/3 w-72 h-72 bg-red-500/20 blur-[120px] rounded-full"></div>
        </div>        

        <div className={`
            relative z-10
            px-6
            text-center
            max-w-5xl
            mx-auto
            translate-y-[2vh]
            transition-all duration-1000
            ${
              visibleSections.has("header")
                ? "opacity-100"
                : "opacity-0 translate-y-[5vh]"
            }
          `}>
          <h1 className="
              font-bricolage
              font-bold
              tracking-tight
              leading-tight
              mb-4
              bg-gradient-to-r
              from-red-400 via-white to-blue-800
              bg-clip-text text-transparent
              text-[clamp(2rem,6vw,4.5rem)]">
            {sectionHero.page}
          </h1>
          <div className="w-16 md:w-24 h-1 rounded-full bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-5"></div>
          <p className="text-xl mx-auto
            max-w-xs sm:max-w-2xl text-white
            leading-relaxed
            text-[clamp(.95rem,1.8vw,1.15rem)]">
            {sectionHero.description}
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section 
        data-section="services"
        className="py-10 bg-white"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200 ${
          visibleSections.has('services') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index} onClick={() => navigate(service.link)}
                className="cursor-pointer group relative p-8 bg-white backdrop-blur-sm rounded-2xl border border-slate-700 hover:border-transparent transition-all duration-500 transform hover:scale-105 hover:-translate-y-2"
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-10 rounded-2xl transition-opacity duration-500`}></div>
                <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} opacity-0 group-hover:opacity-20 blur-xl transition-opacity duration-500`}></div>
                
                <div className="relative z-10  mb-16">
                  <div className="text-5xl mb-4 transform group-hover:scale-110 transition-transform duration-300">
                    <img
                      src={service.icon}
                      className='h-24 rounded-xl'
                    />
                  </div>
                  <h3 className="text-2xl font-bold mb-3 text-slate-700 group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-white group-hover:to-gray-100 group-hover:bg-clip-text transition-all duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-400 group-hover:text-white transition-colors duration-300 mb-4">
                    {service.desc}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center text-sm text-gray-500 group-hover:text-white transition-colors duration-300">
                        <span className="w-1.5 h-1.5 bg-red-500 hover:bg-white rounded-full mr-2"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="absolute bottom-0 right-5 p-4 text-gray-500 text-right hover:text-blue-500">
                    Baca selengkapnya...
                  </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section 
        data-section="tech"
        className="py-24 bg-slate-100/95 text-slate-700"
      >
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-400 ${
          visibleSections.has('tech') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="text-center mb-4">
            <h2 className="font-bricolage text-2xl sm:text-3xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-red-500 to-[#3E3274] bg-clip-text text-transparent">
              Download Aplikasi Kenzie Komunika APK
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-red-500 to-[#3E3274] mx-auto mb-4"></div>
            <p className="text-gray-400 text-sm sm:text-base md:text-xl max-w-2xl mx-auto">
              Transaksi mudah melalui Kenzie Komunika APK.
            </p>
          </div>

          <div className={`relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 delay-400 `}>
            <Link 
              to="https://play.google.com/store/apps/details?id=com.otoreport.kenziekomunika"
              className="inline-block px-10 py-4 bg-gradient-to-r from-red-500 to-[#3E3274] rounded-full font-semibold text-lg hover:shadow-2xl hover:shadow-blue-500/50 transform hover:scale-125 transition-all duration-300"
            >
              <div className='flex flex-row gap-6 text-white items-center'>
                <IoLogoGooglePlaystore size={25}></IoLogoGooglePlaystore> Kenzie Komunika APK
              </div>
            </Link>
          </div>
        </div>
      </section>

      
    </div>
  );
}
